/**
 * ViewPrepare Reducer
 */

import {
  LOADER_STATUS,
  SET_PREPARED_GSTR9_DATA,
  FETCH_PREPARED_DATA_REQUEST,
  FETCH_PREPARED_DATA_SUCCESS,
  FETCH_PREPARED_DATA_FAILURE,
  SET_AUTODRAFTED_GSTR9_DATA,
  FETCH_AUTODRAFTED_DATA_REQUEST,
  FETCH_AUTODRAFTED_DATA_SUCCESS,
  FETCH_AUTODRAFTED_DATA_FAILURE,
  SET_RECONCILED_GSTR9_DATA,
  FETCH_RECONCILED_DATA_REQUEST,
  FETCH_RECONCILED_DATA_SUCCESS,
  FETCH_RECONCILED_DATA_FAILURE,
  SET_PREPARE_GSTR9_DATA,
  FETCH_PREPARE_DATA_REQUEST,
  FETCH_PREPARE_DATA_SUCCESS,
  FETCH_PREPARE_DATA_FAILURE,
  SET_OVERWRITE_DIALOG_DATA,
  SET_OVERWRITE_SUMMARY_DATA,
  OVERWRITE_AUTO_DRAFTED_REQUEST,
  OVERWRITE_AUTO_DRAFTED_SUCCESS,
  OVERWRITE_AUTO_DRAFTED_FAILURE,
  SET_OVERRIDE_DATA,
  DOWNLOAD_SUMMARY_REPORT_REQUEST,
  DOWNLOAD_SUMMARY_REPORT_SUCCESS,
  DOWNLOAD_SUMMARY_REPORT_FAILURE,
  CLEAR_PREPARED_DATA,
  CLEAR_AUTODRAFTED_DATA,
  CLEAR_RECONCILED_DATA,
  CLEAR_PREPARE_DATA,
  CLEAR_ALL_VIEW_PREPARE_DATA
} from './constants';

const initialState = {
  loaderStatus: false,
  preparedGstr9Data: null,
  autodraftedGstr9Data: null,
  reconciledGstr9Data: null,
  prepareGstr9Data: null,
  isLoading: false,
  error: null,
  lastFetchedData: null,
  lastAutodraftedData: null,
  lastReconciledData: null,
  lastPrepareData: null,
  overwriteDialogData: null,
  overwriteSummaryData: null,
};

function viewPrepareReducer(state = initialState, action) {
  // console.log('ViewPrepare Reducer - Action received:', action.type);
  if (action.type === SET_PREPARED_GSTR9_DATA) {
    // console.log('ViewPrepare Reducer - SET_PREPARED_GSTR9_DATA payload:', action.payload);
    // console.log('ViewPrepare Reducer - Previous state:', state.preparedGstr9Data);
  }
  
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };

    case SET_PREPARED_GSTR9_DATA:
      const newState = {
        ...state,
        preparedGstr9Data: action.payload,
      };
      console.log('ViewPrepare Reducer - New state after SET_PREPARED_GSTR9_DATA:', newState.preparedGstr9Data);
      return newState;

    case FETCH_PREPARED_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_PREPARED_DATA_SUCCESS:
      console.log("action.payload",action.payload)
      return {
        ...state,
        isLoading: false,
        error: null,
        lastFetchedData: action.payload,
      };

    case FETCH_PREPARED_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        lastFetchedData: null,
      };

    case SET_AUTODRAFTED_GSTR9_DATA:
      const newAutodraftedState = {
        ...state,
        autodraftedGstr9Data: action.payload,
      };
      console.log('ViewPrepare Reducer - New state after SET_AUTODRAFTED_GSTR9_DATA:', newAutodraftedState.autodraftedGstr9Data);
      return newAutodraftedState;

    case FETCH_AUTODRAFTED_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_AUTODRAFTED_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        lastAutodraftedData: action.payload,
      };

    case FETCH_AUTODRAFTED_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        lastAutodraftedData: null,
      };

    case SET_RECONCILED_GSTR9_DATA:
      const newReconciledState = {
        ...state,
        reconciledGstr9Data: action.payload,
      };
      console.log('ViewPrepare Reducer - New state after SET_RECONCILED_GSTR9_DATA:', newReconciledState.reconciledGstr9Data);
      return newReconciledState;

    case FETCH_RECONCILED_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_RECONCILED_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        lastReconciledData: action.payload,
      };

    case FETCH_RECONCILED_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        lastReconciledData: null,
      };

    case SET_PREPARE_GSTR9_DATA:
      const newPrepareState = {
        ...state,
        prepareGstr9Data: action.payload,
      };
      console.log('ViewPrepare Reducer - New state after SET_PREPARE_GSTR9_DATA:', newPrepareState.prepareGstr9Data);
      return newPrepareState;

    case FETCH_PREPARE_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_PREPARE_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        lastPrepareData: action.payload,
      };

    case FETCH_PREPARE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        lastPrepareData: null,
      };

    case SET_OVERWRITE_DIALOG_DATA:
      console.log('ViewPrepare Reducer - Setting overwrite dialog data:', action.payload);
      console.log('ViewPrepare Reducer - Payload keys:', Object.keys(action.payload || {}));
      return {
        ...state,
        overwriteDialogData: action.payload,
      };

    case SET_OVERWRITE_SUMMARY_DATA:
      console.log('ViewPrepare Reducer - Setting overwrite summary data:', action.payload);
      return {
        ...state,
        overwriteSummaryData: action.payload,
      };

    case OVERWRITE_AUTO_DRAFTED_REQUEST:
      console.log('ViewPrepare Reducer - Overwrite auto drafted request started');
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case OVERWRITE_AUTO_DRAFTED_SUCCESS:
      console.log('ViewPrepare Reducer - Overwrite auto drafted success');
      return {
        ...state,
        isLoading: false,
        error: null,
        overwriteDialogData: null,
        overwriteSummaryData: null,
      };

    case OVERWRITE_AUTO_DRAFTED_FAILURE:
      console.log('ViewPrepare Reducer - Overwrite auto drafted failure:', action.payload);
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case SET_OVERRIDE_DATA:
            return {
              ...state,
              overloadedData:action.payload
            }
    case DOWNLOAD_SUMMARY_REPORT_REQUEST:
      console.log('ViewPrepare Reducer - Download summary report request started');
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case DOWNLOAD_SUMMARY_REPORT_SUCCESS:
      console.log('ViewPrepare Reducer - Download summary report success');
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case DOWNLOAD_SUMMARY_REPORT_FAILURE:
      console.log('ViewPrepare Reducer - Download summary report failure:', action.payload);
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case CLEAR_PREPARED_DATA:
      return {
        ...state,
        preparedGstr9Data: null,
        lastFetchedData: null,
        error: null,
      };

    case CLEAR_AUTODRAFTED_DATA:
      return {
        ...state,
        autodraftedGstr9Data: null,
        lastAutodraftedData: null,
        error: null,
      };

    case CLEAR_RECONCILED_DATA:
      return {
        ...state,
        reconciledGstr9Data: null,
        lastReconciledData: null,
        error: null,
      };

    case CLEAR_PREPARE_DATA:
      return {
        ...state,
        prepareGstr9Data: null,
        lastPrepareData: null,
        error: null,
      };

    case CLEAR_ALL_VIEW_PREPARE_DATA:
      return {
        ...state,
        preparedGstr9Data: null,
        autodraftedGstr9Data: null,
        reconciledGstr9Data: null,
        prepareGstr9Data: null,
        lastFetchedData: null,
        lastAutodraftedData: null,
        lastReconciledData: null,
        lastPrepareData: null,
        overwriteDialogData: null,
        overwriteSummaryData: null,
        error: null,
        isLoading: false,
      };

    default:
      return state;
  }
}

export default viewPrepareReducer;